import React, { useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import { Container, Table, Card, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmailStats } from '../features/logSlice';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const EmailStatsPage = () => {
  const dispatch = useDispatch();
  const token = useSelector(state => state.auth.token);
  const { stats } = useSelector(state => state.logs);

  useEffect(() => {
    dispatch(fetchEmailStats(token));
  }, [dispatch, token]);

  const exportCSV = () => {
    const csv = [
      ['Email', 'Total Chats'],
      ...stats.map(item => [item.email, item.total])
    ]
      .map(row => row.join(','))
      .join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'email_stats.csv');
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, {
      head: [['Email', 'Total Chats']],
      body: stats.map(item => [item.email, item.total]),
    });
    doc.save('email_stats.pdf');
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <Container fluid style={{ marginLeft: '220px' }} className="pt-4">
        <h4>Email Usage Analytics</h4>

        <Card className="p-3 shadow-sm mt-3">
          <div className="text-end mb-3">
            <Button size="sm" className="me-2" onClick={exportCSV}>Export CSV</Button>
            <Button size="sm" variant="dark" onClick={exportPDF}>Export PDF</Button>
          </div>

          <Table striped hover responsive>
            <thead>
              <tr>
                <th>Email</th>
                <th>Total Chats</th>
              </tr>
            </thead>
            <tbody>
              {stats.length === 0 ? (
                <tr>
                  <td colSpan="2" className="text-center">No email stats yet.</td>
                </tr>
              ) : (
                stats.map((item, i) => (
                  <tr key={i}>
                    <td>{item.email}</td>
                    <td>{item.total}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card>
      </Container>
    </div>
  );
};

export default EmailStatsPage;
